import {
  Button,
  Chip,
  FormControl,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { toast } from "react-toastify";

import apiHelper from "../../../../util/ApiHelper";

const useStyles = makeStyles({
  chip: {
    marginRight: "5px",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function UserForm(props) {
  const [roles, setRoles] = React.useState([]);
  const [defaultValue, setDefaultValue] = React.useState({
    email: "",
    username: "",
    password: "",
    roleIds: [],
  });
  const { control, reset, handleSubmit } = useForm({
    defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
  });

  const history = useHistory();
  const classes = useStyles();

  const getAdminDetail = React.useCallback(async () => {
    if (typeof props.match.params.id !== "undefined") {
      try {
        const id = props.match.params.id;
        const result = await apiHelper.cinefan.getAdminById(id);
        // console.log("ResponseAdmin: ", response);
        const adminInfo = {
          ...result.data,
          roleIds: result.data.roles.map(role => role.id),
        };
        setDefaultValue(adminInfo);
        reset(adminInfo);
      } catch (err) {
        console.log(err);
      }
    }
  }, [props.match, reset]);

  const getRoles = async () => {
    const result = await apiHelper.cinefan.getRoles();
    setRoles(result.data);
  };

  const onSubmit = async (values) => {
    console.log(values);
    try {
      if (props.mode === "edit") {
        const result = await apiHelper.cinefan.updateAdminById(
          values.id,
          values
        );
        console.log(result.data);
        if (result.data.id) {
          props.handleClose();
          toast.dark("Your changes is saved.");
          history.push(`/cinefan/permission/manage/${props.currentRole}`);
        }
      } else {
        const result = await apiHelper.cinefan.addAdmins(values);
        // console.log(result.data.code);
        if (result.data.id) {
          props.handleClose();
          toast.dark("Admin created.");
          history.push(`/cinefan/permission/manage/${props.currentRole}`);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    getAdminDetail();
  }, [getAdminDetail]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container direction="column" spacing={3}>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="username"
            rules={{ required: "Required" }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                margin="dense"
                label="Username"
                variant="outlined"
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="email"
            rules={{ required: "Required" }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                margin="dense"
                label="Email"
                variant="outlined"
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="password"
            rules={{
              required: "Required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                margin="dense"
                label="Password"
                type="password"
                variant="outlined"
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            defaultValue={defaultValue.roleIds}
            name="roleIds"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth variant="outlined" margin="dense">
                <Select
                  multiple
                  // labelId="demo-mutiple-chip-label"
                  // id="demo-mutiple-chip"
                  renderValue={(selected) => (
                    <div>
                      {roles
                        .filter((role) => selected.includes(role.id))
                        .map((value) => (
                          <Chip
                            key={value.id}
                            label={value.name}
                            className={classes.chip}
                          />
                        ))}
                    </div>
                  )}
                  {...field}
                  MenuProps={MenuProps}
                >
                  {roles &&
                    roles.map((role) => (
                      <MenuItem key={role.id} value={role.id}>
                        {role.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
        <Grid
          container
          display="flex"
          alignItems="center"
          justify="flex-end"
          style={{ marginTop: "30px" }}
        >
          <Button
            type="cancel"
            variant="string"
            disableElevation
            style={{
              color: "#306F9D",
              marginRight: "5px",
              padding: "9px 16px",
            }}
            onClick={props.handleClose}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disableElevation
            style={{
              color: "white",
              background: "#306F9D",
              marginRight: "5px",
              padding: "9px 16px",
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
